import React, { useMemo } from 'react';
import { FollowersCount } from '../followersCount/FollowersCount';
import { OneSystemCustomer } from '../oneSystemCustomer/OneSystemCustomer';
import { ImmoAwardLabel } from '../immoAwardLabel/ImmoAwardLabel';
import AgentRatings from '../agentratings/AgentRatings';
import { useAppSelector } from '../../store/store';
var selectShowOneSystem = function selectShowOneSystem(state) {
  var _state$config$SHOW_ON, _state$config;
  return (_state$config$SHOW_ON = (_state$config = state.config) === null || _state$config === void 0 ? void 0 : _state$config.SHOW_ONE_SYSTEM) !== null && _state$config$SHOW_ON !== void 0 ? _state$config$SHOW_ON : false;
};
var selectShowImmoAward = function selectShowImmoAward(state) {
  var _state$config$SHOW_IM, _state$config2;
  return (_state$config$SHOW_IM = (_state$config2 = state.config) === null || _state$config2 === void 0 ? void 0 : _state$config2.SHOW_IMMO_AWARD) !== null && _state$config$SHOW_IM !== void 0 ? _state$config$SHOW_IM : false;
};
export var ProfileStats = function ProfileStats(_ref) {
  var evaluations = _ref.evaluations,
    followersCount = _ref.followersCount,
    eligibleToBeFollowed = _ref.eligibleToBeFollowed,
    oneSystemCustomer = _ref.oneSystemCustomer,
    immoAwardWinner = _ref.immoAwardWinner,
    immoAwardFinalist = _ref.immoAwardFinalist;
  var showOneSystem = useAppSelector(selectShowOneSystem);
  var showImmoAward = useAppSelector(selectShowImmoAward);
  var stats = useMemo(function () {
    var hasValidFollowersCount = followersCount != null && followersCount > 0;
    var hasRenderableRatings = (evaluations === null || evaluations === void 0 ? void 0 : evaluations.averageRating) != null && evaluations.averageRating > 0 && (evaluations === null || evaluations === void 0 ? void 0 : evaluations.overallNumberOfEvaluations) != null && evaluations.overallNumberOfEvaluations > 0;
    var shouldShowFollowers = hasValidFollowersCount && eligibleToBeFollowed;
    var shouldShowOneSystem = showOneSystem && oneSystemCustomer;
    var shouldShowImmoAward = showImmoAward && (immoAwardWinner || immoAwardFinalist);
    var shouldShowBadgeRow = shouldShowOneSystem || shouldShowImmoAward;
    var immoAwardVariant = immoAwardWinner ? 'winner' : 'finalist';
    return {
      hasRenderableRatings: hasRenderableRatings,
      shouldShowFollowers: shouldShowFollowers,
      shouldShowOneSystem: shouldShowOneSystem,
      shouldShowImmoAward: shouldShowImmoAward,
      shouldShowBadgeRow: shouldShowBadgeRow,
      immoAwardVariant: immoAwardVariant
    };
  }, [evaluations, followersCount, showOneSystem, oneSystemCustomer, showImmoAward, immoAwardWinner, immoAwardFinalist, eligibleToBeFollowed]);
  return /*#__PURE__*/React.createElement("div", {
    className: "grid-flex margin-bottom-xxl one-whole grid-align-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-flex"
  }, stats.hasRenderableRatings && /*#__PURE__*/React.createElement(AgentRatings, {
    evaluations: evaluations
  }), stats.hasRenderableRatings && stats.shouldShowFollowers && /*#__PURE__*/React.createElement("span", {
    className: "font-body-large-bold grid-align-center margin-bottom-s palm-margin-bottom margin-horizontal-xs palm-margin-horizontal-s"
  }, "."), stats.shouldShowFollowers && /*#__PURE__*/React.createElement(FollowersCount, {
    followersCount: followersCount
  })), stats.shouldShowBadgeRow && /*#__PURE__*/React.createElement("div", {
    className: "one-whole margin-top palm-margin-top-l"
  }, stats.shouldShowOneSystem && /*#__PURE__*/React.createElement(OneSystemCustomer, null), stats.shouldShowImmoAward && /*#__PURE__*/React.createElement(ImmoAwardLabel, {
    variant: stats.immoAwardVariant
  })));
};